import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const CookieGuard: CanActivateFn = (route, state) => {
  const apiService = inject(ApiService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return apiService.get('check-cookie').pipe(
    map(() => true),
    catchError(() => {
      authService.clearAuthData();
      return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
    })
  );
};
